import { FunctionComponent } from 'react';
import { useSearchModalsContentQuery } from '../../../graphql/useSearchModalsContentQuery';
import { mapApiFiltersOptionsToFilterOptions } from '../../../helpers/mapSelectOptions';
import { PropertyConfigModal } from '../../../components/PropertyConfigModal/PropertyConfigModal';
import { useRecentSearches } from '@property.com.au/ui-kit';
import { useAccountContext } from '../../../app-kit/contexts/AccountContext/AccountContext';
import { useSearchLandingPageContext } from '../../contexts/SearchLandingPageContext/SearchLandingPageContext';

interface SearchLandingPagePropertyConfigModalWithDataProps {
  onClose: () => void;
}

export const SearchLandingPagePropertyConfigModalWithData: FunctionComponent<
  SearchLandingPagePropertyConfigModalWithDataProps
> = ({ onClose }) => {
  const { data, fetching } = useSearchModalsContentQuery();
  const { searchQuery } = useSearchLandingPageContext();
  const { isSignedIn } = useAccountContext();
  const { saveRecentLocationSearch } = useRecentSearches({ isSignedIn });
  if (fetching) return null;
  const searchModalsContent = data?.searchModalsContent;
  const { title = '', subtitle = '' } = searchModalsContent?.modals?.propertyConfig ?? {};
  if (!searchModalsContent?.filterOptions) return null;

  return (
    <PropertyConfigModal
      onClose={onClose}
      searchQuery={searchQuery}
      saveRecentLocationSearch={saveRecentLocationSearch}
      title={title}
      subtitle={subtitle}
      filterOptions={mapApiFiltersOptionsToFilterOptions(searchModalsContent.filterOptions)}
    />
  );
};
